module.exports = __webpack_public_path__ + "static/img/far1.270f356e.png";